/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  styles.ts
 */

import { type Theme, css } from '@emotion/react'
import {
  BREAKPOINT_374,
  BREAKPOINT_480,
  BREAKPOINT_MOBILE,
  Z_INDEX_GROUP_10,
} from '@zcode-ui/themes'

export const mobileContainer = css`
  height: 40vh;
  position: relative;
  z-index: ${Z_INDEX_GROUP_10};
`

export const headerContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const headerContent = css`
  margin: 0 24px;

  @media (max-width: ${BREAKPOINT_374}) {
    margin: 0 10px;
  }
`

export const homeButton = css`
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
`

export const userMenuButton = css`
  background: #f1f1ed;
  border-radius: 20px;
  border: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
`

export const textContainer = css`
  margin-top: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${BREAKPOINT_480}) {
    margin-top: 60px;
  }
`

export const headerText = ({ colors, typography }: Theme) => css`
  font-size: 50px;
  line-height: 54px;
  width: 420px;
  letter-spacing: -1px;
  text-align: center;

  @media (max-width: ${BREAKPOINT_480}) {
    font-size: ${typography?.fontSize40};
    width: 321px;
    line-height: ${typography?.fontSize40};
  }
`

export const subHeaderText = ({ colors, typography }: Theme) => css`
  margin: 24px 0 0;
  width: 300px;
  text-align: center;
  font-size: 24px;
  line-height: 32px;
  font-family: var(--chakra-fonts-body);
  font-weight: var(--chakra-fontWeights-medium);

  @media (max-width: ${BREAKPOINT_480}) {
    width: 321px;
    font-size: ${typography?.fontSize20};
    line-height: 28px;
    margin: 12px 0 0;
  }
`

export const formContainer = css`
  position: absolute;
  top: 0;
  border-radius: 6px;
  height: 56px;
  width: 475px;
  right: 50%;
  transform: translate(50%, -50%);

  form label input[type='search'] {
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
    border-radius: 6px;

    @media (max-width: ${BREAKPOINT_MOBILE}) {
      text-align: center;
      padding: 0 16px 0 0;
    }
  }

  @media (max-width: ${BREAKPOINT_480}) {
    left: 24px;
    right: 24px;
    width: initial;
    transform: translate(0, -50%);
  }
`

export const trademark = css`
  font-size: 12px;
  position: relative;
  top: -2em;
`
